import {
  PDFViewer,
  Document,
  StyleSheet,
  Page,
  View,
  Text,
  Font
} from '@react-pdf/renderer'
import React, { useEffect, useState } from 'react'
//@ts-ignore
import font from '../../../assets/fonts/OpenSauceSans-Bold.ttf'
//@ts-ignore
import fontRegular from '../../../assets/fonts/OpenSauceSans-Regular.ttf'
import PdfView from '../../../components/Display/PdfView'
import { formatPipe } from '../../../utils/utils'
import {DateTime} from 'luxon'



const DiaryBook : React.FC<IDiaryBooks> = ({data, dateFrom, dateTo, businessSocial, businessDocument}) => {
  
    Font.register({
        family: 'Open Sans',
        fonts: [{ src: font }],
      })

    Font.register({
        family: 'Open Sans-normal',
        fonts: [{ src: fontRegular }],
    })

  const styles = StyleSheet.create({
    headerContainer: {
      textAlign: 'center',
    },
    flexColContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-between',
      marginTop: 30,
    },
  })

//   const [data, setData] = useState<any[]>([
//     {
//       date: '21/01/2023',
//       amount: 2147,
//       description: 'Pago de nómina empleados',
//       type: 'HABER',
//       code: 125257,
//       account: 'Fecha nómina empleados',
//     },
//     {
//       date: '21/01/2023',
//       amount: 2147,
//       description: 'Pago de nómina empleados',
//       type: 'HABER',
//       code: 125257,
//       account: 'Fecha nómina empleados',
//     },
//     {
//         date: '21/01/2023',
//         amount: 2147,
//         description: 'Pago de nómina empleados',
//         type: 'HABER',
//         code: 125257,
//         account: 'Fecha nómina empleados',
//       }, {
//         date: '21/01/2023',
//         amount: 2147,
//         description: 'Pago de nómina empleados',
//         type: 'HABER',
//         code: 125257,
//         account: 'Fecha nómina empleados',
//       }, {
//         date: '21/01/2023',
//         amount: 2147,
//         description: 'Pago de nómina empleados',
//         type: 'HABER',
//         code: 125257,
//         account: 'Fecha nómina empleados',
//       }, {
//         date: '21/01/2023',
//         amount: 2147,
//         description: 'Pago de nómina empleados',
//         type: 'HABER',
//         code: 125257,
//         account: 'Fecha nómina empleados',
//       }, {
//         date: '21/01/2023',
//         amount: 2147,
//         description: 'Pago de nómina empleados',
//         type: 'HABER',
//         code: 125257,
//         account: 'Fecha nómina empleados',
//       }, {
//         date: '21/01/2023',
//         amount: 2147,
//         description: 'Pago de nómina empleados',
//         type: 'HABER',
//         code: 125257,
//         account: 'Fecha nómina empleados',
//       }, {
//         date: '21/01/2023',
//         amount: 2147,
//         description: 'Pago de nómina empleados',
//         type: 'HABER',
//         code: 125257,
//         account: 'Fecha nómina empleados',
//       }, {
//         date: '21/01/2023',
//         amount: 2147,
//         description: 'Pago de nómina empleados',
//         type: 'HABER',
//         code: 125257,
//         account: 'Fecha nómina empleados',
//       }, {
//         date: '21/01/2023',
//         amount: 2147,
//         description: 'Pago de nómina empleados',
//         type: 'HABER',
//         code: 125257,
//         account: 'Fecha nómina empleados',
//       }, {
//         date: '21/01/2023',
//         amount: 2147,
//         description: 'Pago de nómina empleados',
//         type: 'HABER',
//         code: 125257,
//         account: 'Fecha nómina empleados',
//       },
//   ])

  return (
      <Document title={`libro-diario`}>
        <Page size="LETTER" style={{ padding: 30 }}>
          <View style={styles.headerContainer}>
            <Text style={{ marginBottom: 10, fontFamily: 'Open Sans', fontSize: 15 }}>
              Libro Diario
            </Text>
            <Text style={{ marginBottom: 10, fontFamily: 'Open Sans-normal', fontSize: 15 }}>{businessSocial}</Text>
            <Text style={{ fontSize: 10, marginBottom: 10, fontFamily: 'Open Sans-normal' }}>
              {businessDocument}
            </Text>
            <Text style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}>{dateFrom} hasta {dateTo}</Text>
          </View>

          <View style={styles.flexColContainer}>
            <View style={{ flexBasis: '10%' }}>
              <Text style={{ textAlign: 'center', fontSize: 10, fontFamily: 'Open Sans' }}>Fecha</Text>
            </View>

            <View style={{ flexBasis: '10%' }}>
              <Text style={{ textAlign: 'center', fontSize: 10, fontFamily: 'Open Sans' }}>Monto</Text>
            </View>

            <View style={{ flexBasis: '15%' }}>
              <Text style={{ textAlign: 'center', fontSize: 10, fontFamily: 'Open Sans' }}>
                Descripción
              </Text>
            </View>

            <View style={{ flexBasis: '10%' }}>
              <Text style={{ textAlign: 'center', fontSize: 10, fontFamily: 'Open Sans' }}>Tipo</Text>
            </View>

            <View style={{ flexBasis: '20%' }}>
              <Text style={{ textAlign: 'center', fontSize: 10, fontFamily: 'Open Sans' }}>
                Código cuenta contable
              </Text>
            </View>

            <View style={{ flexBasis: '20%' }}>
              <Text style={{ textAlign: 'center', fontSize: 10, fontFamily: 'Open Sans' }}>
                Cuenta contable
              </Text>
            </View>
          </View>

          {data &&
            data.map((row, index) => (
                <View style={{ ...styles.flexColContainer, paddingHorizontal: 10, paddingVertical: 5, borderRadius: 8, marginTop: 10, backgroundColor: index % 2 === 0 ? '#e7eaf6' : 'white' }}>
                  {console.log("ROW", row)}
                <View style={{ flexBasis: '10%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Text style={{ textAlign: 'center', fontSize: 10 }}>
                    {DateTime.fromISO(row?.date).toFormat("dd/MM/yyyy")}
                  </Text>
                </View>

                <View style={{ flexBasis: '10%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Text style={{ textAlign: 'center', fontSize: 10 }}>
                    {formatPipe(row?.amount)}
                  </Text>
                </View>

                <View style={{ flexBasis: '15%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Text style={{ textAlign: 'center', fontSize: 10 }}>
                    {row?.description}
                  </Text>
                </View>

                <View style={{ flexBasis: '10%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Text style={{ textAlign: 'center', fontSize: 10 }}>
                    {row?.type}
                  </Text>
                </View>

                <View style={{ flexBasis: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Text style={{ textAlign: 'center', fontSize: 10 }}>
                    {row?.code}
                  </Text>
                </View>

                <View style={{ flexBasis: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Text style={{ textAlign: 'center', fontSize: 10 }}>
                    {row?.name}
                  </Text>
                </View>
              </View>
            ))}
        </Page>
      </Document>
  )
}

export interface IDiaryBooks {
    data: any[]
    dateFrom: string
    dateTo: string
    businessSocial: string
    businessDocument: string
}

export default DiaryBook
